import { styled } from "@mui/material/styles";
import { COLOR } from "../../styles/color";
import { Box } from "@mui/material";

export const StyledLogin = styled(Box)`
  width: 350px;
  margin: 150px auto 0;
  padding: 20px;
`;
